import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Location } from '@angular/common';
import { removeDebugNodeFromIndex } from '@angular/core/src/debug/debug_node';
import { GrowlModule } from 'primeng/growl';
import { Message } from 'primeng/components/common/api';
import * as $ from 'jquery';
import { SelectItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { DetailDto } from 'src/app/models/Detail';
import { SaveDataDto } from 'src/app/models/SaveData';
import { checkAndUpdateBinding } from '@angular/core/src/view/util';
declare function tableEditable(): any;


@Component({
  selector: 'app-selection-form',
  templateUrl: './selection-form.component.html',
  styleUrls: ['./selection-form.component.css'],
  providers: [ConfirmationService]
})




export class SelectionFormComponent implements OnInit {

  public hidePO = false;
  public hideSO = false;
  public txtPlant: string = "";
  public txtFactory: string = "";
  public txtMulFactory: string = "";
  public txtValueStream: string = "";
  public txtMulValueStream: string = "";
  public txtstartDate: Date;
  public txtendDate: Date;
  public txtColumns: string = "";
  public txtSO: string = "";
  public txtMulSO: string = "";
  public txtLineItem: string = "";
  public txtMulLineItem: string = "";
  public txtPO: string = "";
  public txtMulPO: string = "";
  public txtCustomer: string = "";
  public txtMulCustomer: string = "";
  public txtStyle: string = "";
  public txtMulStyle: string = "";
  public txtFGNum: string = "";
  public txtMulFGNum: string = "";
  public txtMatType: string = "";
  public txtMulMatType: string = "";
  public txtrawMatCode: string = "";
  public txtMulMatCode: string = "";
  public txtMatGrp: string = "";
  public txtMulMatGrp: string = "";
  public txtpuchGrp: string = "";
  public txtMulpuchGrp: string = "";
  public opt: string = "";
  public showErrMsg = false;
  public msg: string;
  public index = 1;
  public showLoadMsg = false;
  public showLoadMsg1 = false;
  public showLoadMsg_1 = false;
  public clickModalRed = false;
  public shwDetailSummary = false;
  public showErrMsg1 = false;
  public errorMsgDisplay: string = "";
  public errorMessage: string = "";
  public colours: SelectItem[];
  public plants: SelectItem[];
  public selectedColours: string[] = [];
  public stoLocations = [];
  public selectedPlants: string[] = [];
  public CommentMessage = "";
  public commentMsgShow = false;

  public displayBoxArr: any = [[]];
  //public lines: Array<any> = [];
  public lines: Array<any> = [];
  public rmPercentage: string = "";
  public tokenID: string = "";
  public summaryReport: Array<any> = [];
  public DetailReport: Array<any> = [];
  public selectedFactory: string = "";
  public selectedDate: string = "";
  public txtComment: string = "";
  public selectedStoLocation: string = "";

  public txtBoxDate: string = "";
  public txtfactoryLine: string = "";
  public showoutput = false;
  public executeDisable = false;
  public msgs: Message[] = [];
  public errmsgs: Message[] = [];
  public username: string = "";
  public lblUserName: string = "";
  public downloadData = {};
  public downloadDataSum = {};
  public modalViewSummary = {};
  public modalViewDetail = {};
  public showSOSummaryDetail = false;
  public showPOSummaryDetail = false;
  public display: boolean = false;
  public displayValStre: boolean = false;
  public displaytxtSO: boolean = false;
  public displaytxtLineItem: boolean = false;
  public displaytxtPO: boolean = false;
  public displayCustomer: boolean = false;
  public displayStyle: boolean = false;
  public displayFGNum: boolean = false;
  public displayMatType: boolean = false;
  public displayMatCode: boolean = false;
  public displayMatGrp: boolean = false;
  public displaypuchGrp: boolean = false;
  public req: boolean = false;
  public mngErrors: boolean = false;
  public mngErrors2: boolean = false;

  public selectedLineItems: any[] = [];

  constructor(private http: HttpClient, private router: Router, private dataservice: LayoutService, private _location: Location, private confirmationService: ConfirmationService, private adalSvc: MsAdalAngular6Service) { //with single sign on
  //constructor(private http: HttpClient, private router: Router, private dataservice: LayoutService, private _location: Location, private confirmationService: ConfirmationService) { //without single sign on

    //=====================
    //with single sign on
    //====================
    this.username = this.adalSvc.userInfo.userName;
    if (this.username.indexOf("@masholdings.com") == -1) {
      this.username = this.username[0].toUpperCase() + this.username.substr(1).toLowerCase();
    }
    else {
      this.username = this.username[0].toUpperCase() + this.username.substr(1).toLowerCase().replace("@masholdings.com", "");

    }

    this.colours = [
      { label: 'Not Allocated', value: 'R' },
      { label: 'Not Planned', value: 'Y' },
      { label: 'Ok', value: 'G' },
      { label: 'Factory Closed', value: 'W' },
      { label: 'Partially Commented', value: 'RB' },
      { label: 'Commented All', value: 'RG' }
    ];
    this.stoLocations = [
      { name: '0030 - ZACC', code: '0030' },
      { name: '0040 - ZFAB', code: '0040' }
    ];

    this.plants = [{ label: 'B051', value: 'B051' }, { label: 'B100', value: 'B100' }, { label: 'F051', value: 'F051' },{ label: 'A054', value: 'A054' },{ label: 'A058', value: 'A058' }];

    //----------------without single sign on---------------------


    //  let login = sessionStorage.getItem("LoginSession");
    //  if (login != null) {
    //    if (login == "true") {
    //      if (sessionStorage.getItem("UserName")[0].indexOf("@masholdings.com") == -1) {
    //        this.username = sessionStorage.getItem("UserName")[0].toUpperCase() + sessionStorage.getItem("UserName").substr(1).toLowerCase();
    //        this.username = this.username[0].toUpperCase() + this.username.substr(1).toLowerCase();
    //      }
    //      else {
    //        this.username = this.username[0].toUpperCase() + this.username.substr(1).toLowerCase().replace("@masholdings.com", "");
    //       this.username = sessionStorage.getItem("UserName")[0].toUpperCase() + sessionStorage.getItem("UserName").substr(1).toLowerCase().replace("@masholdings.com", "");

    //     }

    //     this.colours = [
    //       { label: 'Not Allocated', value: 'R' },
    //       { label: 'Not Planned', value: 'Y' },
    //       { label: 'Ok', value: 'G' },
    //       { label: 'Factory Closed', value: 'W' },
    //       { label: 'Partially Commented', value: 'RB' },
    //       { label: 'Commented All', value: 'RG' }
    //     ];
    //     this.stoLocations = [
    //       { name: '0030 - ZACC', code: '0030' },
    //       { name: '0040 - ZFAB', code: '0040' }
    //     ];
    //     this.plants = [{ label: 'B051', value: 'B051' }, { label: 'B100', value: 'B100' }, { label: 'F051', value: 'F051' }];

    //  }
    //   else {
    //      this.router.navigateByUrl('/login');
    //  }
    //  else {
    // this.router.navigatebyurl('/login');
    //  }

    //--------end of without sigle sign on
  }

  ngOnInit() {
    tableEditable();
  }

  collapseForm() {

    var element = document.getElementById("headingOne");

    if (element.classList.contains('active')) {
      element.classList.remove('active');
    }
    else {
      element.classList.add('active');

    }

    // 

  }



  SalesOrderRDoChange(evt) {

    //var target = evt.target;
    // if (target.checked) {
    //   this.hidePO=true;
    //   this.hideSO=false;
    // }
    if (this.opt == "S") {
      this.displayBoxArr = [];
      this.lines = [];
      this.summaryReport = [];
      this.DetailReport = [];
      this.hidePO = true;
      this.hideSO = false;
      this.showSOSummaryDetail = true;
      this.showPOSummaryDetail = false;
      this.req = true;
      this.rmPercentage = "";
      this.txtPO = "";

    }
  }
  PORdoChange(evt) {
    // var target = evt.target;
    // if (target.checked) {
    //   this.hidePO=false;
    //   this.hideSO=true;
    // }
    if (this.opt == "P") {
      this.displayBoxArr = [];
      this.lines = [];
      this.summaryReport = [];
      this.DetailReport = [];
      this.hidePO = false;
      this.hideSO = true;
      this.showSOSummaryDetail = false;
      this.showPOSummaryDetail = true;
      this.req = false;
      this.rmPercentage = "";
      this.txtSO = "";
      this.txtLineItem = "";
    }
  }

  // spanClick()
  // {
  //   var $TABLE = $('#table');
  //   var $BTN = $('#export-btn');
  //   var $EXPORT = $('#export');
  //   var $clone = $TABLE.find('tr.hide').clone(true).removeClass('hide table-line');
  //   $TABLE.find('table').append($clone); 
  // }

  Execute() {

    var element = document.getElementById("headingOne");

    if (element.classList.contains('active')) {
      element.classList.remove('active');
    }
    else {
      element.classList.add('active');

    }
debugger;
    this.showLoadMsg = true;
    debugger;
    var plants = this.selectedPlants[0] + "," + this.selectedPlants[1] + "," + this.selectedPlants[2]+ "," + this.selectedPlants[3]+ "," + this.selectedPlants[4];
    var factory = this.txtFactory;
    var valueStream = this.txtValueStream;
    // var startDate=this.txtstartDate;
    // var endDate=this.txtendDate;
    var customer = this.txtCustomer;
    var style = this.txtStyle;
    var FG = this.txtFGNum;
    var matType = this.txtMatType;
    var RM = this.txtrawMatCode;
    var matGrp = this.txtMatGrp;
    var PO = this.txtpuchGrp;
    var rdoBtnVal = this.opt;
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    var stoLocation = "";

    if (this.selectedStoLocation != undefined) {
      stoLocation = this.selectedStoLocation["code"];
    }
    else {
      stoLocation = "";
    }

    var selectedColors = "";
    if (this.selectedColours.length == 0) {
      selectedColors = "R,Y,G,W,RB,RG";
    }
    else {
      selectedColors = this.selectedColours[0] + "," + this.selectedColours[1] + "," + this.selectedColours[2] + "," + this.selectedColours[3] + "," + this.selectedColours[4] + "," + this.selectedColours[5];
    }

    if (this.txtstartDate == null || this.txtendDate == null) {
      this.showLoadMsg = false;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill the required fields.' });
    }
    else {
      let Sday = this.txtstartDate.getDate();
      let Smonth = this.txtstartDate.getMonth() + 1; // add 1 because months are indexed from 0
      let Syear = this.txtstartDate.getFullYear();

      let Eday = this.txtendDate.getDate();
      let Emonth = this.txtendDate.getMonth() + 1; // add 1 because months are indexed from 0
      let Eyear = this.txtendDate.getFullYear();

      var startDate = Smonth + '/' + Sday + '/' + Syear;
      var endDate = Emonth + '/' + Eday + '/' + Eyear;

      // var startDate = Sday + '/' + Smonth + '/' + Syear;
      // var endDate = Eday + '/' + Emonth + '/' + Eyear;

      let Sdate = new Date(this.txtstartDate);
      let Edate = new Date(this.txtendDate);

      var dateDiff = Math.abs(Edate.valueOf() - Sdate.valueOf());
      var diffDays = (Math.ceil(dateDiff / (1000 * 3600 * 24))) + 1;
    }
    if (this.opt == "S") {
      if (this.selectedPlants.length == 0 || rdoBtnVal == "" || startDate == undefined || endDate == undefined || stoLocation == undefined || this.selectedStoLocation == undefined) {
        this.showLoadMsg = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill the required fields.' });
        this.mngErrors = false;
        // if(this.selectedStoLocation==undefined)
        // {
        //   this.showLoadMsg = false;
        //   this.msgs = [];
        //   this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill the required fields.' });

        // }
        // else
        // {
        //   this.showLoadMsg = false;
        //   this.msgs = [];
        //   this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill the required fields.' });

        // }

      }
      else {
        this.mngErrors = true;
      }
    }
    else if (this.opt == "P") {
      if (this.selectedPlants.length == 0 || rdoBtnVal == "" || startDate == undefined || endDate == undefined) {
        this.showLoadMsg = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Please fill the required fields.' });
        this.mngErrors = false;
      }
      else {
        this.mngErrors = true;
      }
    }

    if (diffDays > 14) {
      // this.showErrMsg = true;
      // this.msg = "Date Difference is More than 14.";
      this.showLoadMsg = false;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Date Difference is More than 14.' });
      this.mngErrors2 = false;
    }
    else {
      this.mngErrors2 = true;
    }
    debugger;
    if (this.mngErrors == true && this.mngErrors2 == true) {
      //let username = sessionStorage.getItem("UserName");
      let username = this.username;
      //let username = "AroshaM";
      debugger;
      this.dataservice.GetLayoutData(username, this.opt, plants, this.txtFactory, this.txtValueStream, startDate, endDate, this.txtSO, this.txtLineItem, this.txtCustomer, this.txtFGNum, this.txtMatType, this.txtrawMatCode, this.txtMatGrp, this.txtpuchGrp, this.txtPO, selectedColors, stoLocation, this.txtStyle)

        .subscribe(data => {

          this.errorMessage = data["m_Item5"];
          if (this.errorMessage != "") {
            // this.showErrMsg1=true;
            // this.errorMsgDisplay=this.errorMessage;
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error', detail: this.errorMessage });
            this.shwDetailSummary = false;
            this.showLoadMsg = false;
          }
          else {
            console.log("GET is successful ", data);
            this.displayBoxArr = data["m_Item1"];

            // if(this.selectedColours.indexOf("Not Allocated")!=-1)
            // {
            //   for(var obj of data["m_Item1"])
            //   {
            //     if(obj["BOX_COLOR"]=="R")
            //     {
            //       this.displayBoxArr.push(obj);
            //     }

            //   }

            // }

            if (this.displayBoxArr.length == 0) {
              // this.showErrMsg1=true;
              // this.errorMsgDisplay="No Data to Display.";
              this.showoutput = false;
              this.msgs = [];
              this.msgs.push({ severity: 'error', summary: 'Error', detail: 'No records to display.' });
              this.showLoadMsg = false;
            }
            else {
              this.showoutput = true;
              this.lines = data["m_Item4"];
              console.log("Lines ", this.lines);
              this.rmPercentage = data["m_Item2"];
              this.tokenID = data["m_Item3"];
              this.showErrMsg1 = false;
              this.errorMsgDisplay = "";
              this.showLoadMsg = false;
              this.shwDetailSummary = true;


            }

          }

        }, error => {
          console.log("Error", error);
          this.showLoadMsg = false;
          // this.showErrMsg1=true;
          // this.errorMsgDisplay=error;
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: 'Error', detail: error });
        });
    }

    // sessionStorage.setItem("Plants", this.txtPlant);
    // sessionStorage.setItem("Factory", this.txtFactory);
    // sessionStorage.setItem("ValueStream", this.txtValueStream);
    // sessionStorage.setItem("StartDate", this.txtstartDate);
    // sessionStorage.setItem("EndDate", this.txtendDate);
    // sessionStorage.setItem("Mode", this.opt);

    // this.router.navigateByUrl('/display');




  }

  StartDateChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.showErrMsg = false;
    this.msg = "";

    // let Sday = this.txtstartDate.getDate();
    // let Smonth = this.txtstartDate.getMonth() + 1; // add 1 because months are indexed from 0
    // let Syear = this.txtstartDate.getFullYear();

    // let Eday = this.txtendDate.getDate();
    // let Emonth = this.txtendDate.getMonth() + 1; // add 1 because months are indexed from 0
    // let Eyear = this.txtendDate.getFullYear();

    // var startDate=Smonth + '/' + Sday + '/' + Syear;
    // var endDate=Emonth + '/' + Eday + '/' + Eyear;
    if (this.txtstartDate != null && this.txtendDate != null) {
      let Sdate = new Date(this.txtstartDate);
      let Edate = new Date(this.txtendDate);

      var dateDiff = Math.abs(Edate.valueOf() - Sdate.valueOf());
      var diffDays = (Math.ceil(dateDiff / (1000 * 3600 * 24))) + 1;
      if (diffDays > 14) {
        // this.showErrMsg = true;
        // this.msg = "Date Difference is More than 14.";
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Date Difference is More than 14.' });
      }
      else {
        // this.showErrMsg = false;
        // this.msg = "";
        this.msgs = [];
      }
    }

  }

  EndDateChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.showErrMsg = false;
    this.msg = "";

    // let Sday = this.txtstartDate.getDate();
    // let Smonth = this.txtstartDate.getMonth() + 1; // add 1 because months are indexed from 0
    // let Syear = this.txtstartDate.getFullYear();

    // let Eday = this.txtendDate.getDate();
    // let Emonth = this.txtendDate.getMonth() + 1; // add 1 because months are indexed from 0
    // let Eyear = this.txtendDate.getFullYear();

    // var startDate=Smonth + '/' + Sday + '/' + Syear;
    // var endDate=Emonth + '/' + Eday + '/' + Eyear;
    if (this.txtendDate != null && this.txtstartDate != null) {
      let Sdate = new Date(this.txtstartDate);
      let Edate = new Date(this.txtendDate);

      var dateDiff = Math.abs(Edate.valueOf() - Sdate.valueOf());
      var diffDays = (Math.ceil(dateDiff / (1000 * 3600 * 24))) + 1;
      if (diffDays > 14) {
        //this.executeDisable=true;
        // this.showErrMsg = true;
        // this.msg = "Date Difference is More than 14.";
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error', detail: 'Date Difference is More than 14.' });
      }
      else {
        // this.showErrMsg = false;
        // this.msg = "";
        this.msgs = [];
      }
    }
    else {
      this.msgs = [];
    }
  }

  getStyle(item: any) {
    if (item == "R") {
      //return "#d9544d";
      return "#cb342d";
    }
    else if (item == "Y") {
      return "#eb9621";
    }
    else if (item == "G") {
      return "#148117";
    }
    else if (item == "W") {
      return "White";
    }
    else if (item == "RB") {
      return "#cb342d";

    }
    else if (item == "RG") {
      return "#cb342d";
      //return "btn-danger";
    }
  }

  // getBorderStyle(item:any) {
  //   if (item == "R") {
  //     return "#cb342d";
  // }         
  // else if (item == "Y") {
  //     return "#eb9621";
  // }
  // else if (item == "G") {
  //     return "#148117";
  // }
  // else if (item == "W") {
  //     return "Black";
  // }
  // else  if (item == "RB") {
  //    return "Black";  
  //   }
  // else if (item == "RG") {
  //     return "#148117";
  // }
  // }

  getBorderThickness(item: any) {
    if (item == "R") {
      return "#cb342d";
    }
    else if (item == "Y") {
      return "#eb9621";
    }
    else if (item == "G") {
      return "#148117";
    }
    else if (item == "W") {
      return "1px solid black";
    }
    else if (item == "RB") {
      return "3px solid black";
    }
    else if (item == "RG") {
      return "3px solid #148117";
    }
  }

  getBoxTextColor(item: any) {
    if (item == "R") {
      return "White";
    }
    else if (item == "Y") {
      return "White";
    }
    else if (item == "G") {
      return "White";
    }
    else if (item == "W") {
      return "Black";
    }
    else if (item == "RB") {
      return "White";
    }
    else if (item == "RG") {
      return "White";
    }
  }

  Detail() {

    this.DetailReport = [];
    this.downloadData = {};

    this.dataservice.GetDetailList(this.tokenID)
      // this.dataservice.GetDetailList(this.tokenID, this.txtBoxDate, this.txtfactoryLine)

      .subscribe(data => {
        console.log("GET is successful ", data);
        if (data.length == 0) {
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: 'Error', detail: 'No Data to Download.' });
        }
        else {
          //this.DetailReport=data;
          // debugger;
          if (this.opt == "S") {
            for (var obj of data) {
              this.downloadData = { "Plant": obj["WERKS"], "Sales Order": obj["VBELN"], "Line Item": obj["POSNR"], "Production Order": obj["AUFNR"], "FG Number": obj["FGMATNR"], "FG Description": obj["FGMAKTX"].replace(',', ' '), "Material": "'" + obj["RMMATNR"].replace(/^0+/, ''), "Subcon Identifier": obj["SUBCON"], "Material Description": obj["RMMAKTX"].replace(/,/g, ' '), "GrV": obj["J_3ASIZE"], "Purchase Group": obj["EKGRP"], "Purchase Group Desc": obj["EKNAM"].replace(',', ' '), "Material Type": obj["MTART"], "Storage Location": obj["LGORT"], "Customer Name": obj["EWBEZ"], "Customer": obj["EXTWG"], "Material Group": obj["MATKL"], "Factory": obj["NAME1"], "Production Start Date": obj["START_DATE"], "PCD": obj["CUT_DATE"], "RqDlv.date": obj["J_3ARQDA"], "Batch": obj["CHARG"], "GRN Date": obj["GRN_DATE"], "Total Requirement": obj["REQ_QTY"], "Total Assigned Stock": obj["ASSIGNED_QTY"], "Missing Qty": obj["MISSING_QTY"], "UR Stock": obj["UR_STOCK"], "QI Stock": obj["QI_STOCK"], "Fixed UR Stock": obj["FIXED_UR_STOCK"], "Fixed QI Stock": obj["FIXED_QI_STOCK"], "Blocked Stock": obj["BLOCKED_STOCK"], "PickList Qty": obj["PICKLIST_QTY"], "Excludes": obj["EXCLUDED"], "Supply Chain Comment": obj["MVD_COMMENT"].replace(',', ' '), "Supply Chain User": obj["MVD_COMMENT_USER"], "RMW Comment": obj["RMW_COMMENT"].replace(',', ' '), "RMW User": obj["RMW_COMMENT_USER"], "MQA Comment": obj["MQA_COMMENT"].replace(',', ' '), "MQA User": obj["MQA_COMMENT_USER"], "MCU Comment": obj["MCU_COMMENT"].replace(',', ' '), "MCU User": obj["MCU_COMMENT_USER"] };
              //this.downloadData = { "Plant": obj["WERKS"],"Material Description": obj["RMMAKTX"].replace(/,/g, ' ')};
              this.DetailReport.push(this.downloadData);
            }

            this.ExportToExcel(this.DetailReport, 'DetailReport.csv');
          }
          else {
            // debugger;
            for (var obj of data) {
              this.downloadData = { "Plant": obj["WERKS"], "Sales Order": obj["VBELN"], "Line Item": obj["POSNR"], "Production Order": obj["AUFNR"], "FG Number": obj["FGMATNR"], "FG Description": obj["FGMAKTX"].replace(',', ' '), "Material": "'" + obj["RMMATNR"].replace(/^0+/, ''), "Subcon Identifier": obj["SUBCON"], "Material Description": obj["RMMAKTX"].replace(/,/g, ' '), "Production Order Status": obj["PRD_STATUS"], "GrV": obj["J_3ASIZE"], "Purchase Group": obj["EKGRP"], "Purchase Group Desc": obj["EKNAM"].replace(',', ' '), "Material Type": obj["MTART"], "Storage Location": obj["LGORT"], "Customer Name": obj["EWBEZ"], "Customer": obj["EXTWG"], "Material Group": obj["MATKL"], "Work Center": obj["ARBPL"], "Factory": obj["NAME1"], "Value Stream": obj["VALUEST"], "Production Start Date": obj["START_DATE"], "PCD": obj["CUT_DATE"], "RqDlv.date": obj["J_3ARQDA"], "Batch": obj["CHARG"], "GRN Date": obj["GRN_DATE"], "Total Requirement": obj["REQ_QTY"], "Total Assigned Stock": obj["ASSIGNED_QTY"], "Missing Qty": obj["MISSING_QTY"], "UR Stock": obj["UR_STOCK"], "QI Stock": obj["QI_STOCK"], "Fixed UR Stock": obj["FIXED_UR_STOCK"], "Fixed QI Stock": obj["FIXED_QI_STOCK"], "Blocked Stock": obj["BLOCKED_STOCK"], "PickList Qty": obj["PICKLIST_QTY"], "Excludes": obj["EXCLUDED"], "Supply Chain Comment": obj["MVD_COMMENT"], "Supply Chain User": obj["MVD_COMMENT_USER"], "RMW Comment": obj["RMW_COMMENT"], "RMW User": obj["RMW_COMMENT_USER"], "MQA Comment": obj["MQA_COMMENT"], "MQA User": obj["MQA_COMMENT_USER"], "MCU Comment": obj["MCU_COMMENT"], "MCU User": obj["MCU_COMMENT_USER"] };
              this.DetailReport.push(this.downloadData);
            }

            this.ExportToExcel(this.DetailReport, 'DetailReport.csv');
          }

        }
      }, error => {
        console.log("Error", error);
      });
  }

  Summary() {
    this.downloadDataSum = {};
    this.summaryReport = [];
    this.dataservice.GetSummaryList(this.tokenID)

      .subscribe(data => {
        console.log("GET is successful ", data);
        if (data.length == 0) {
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: 'Error', detail: 'No Data to Download.' });
        }
        else {
          if (this.opt == "S") {
            for (var obj of data) {
              this.downloadDataSum = { "Plant": obj["WERKS"], "Sales Order": obj["VBELN"], "Line Item": obj["POSNR"], "Production Order": obj["AUFNR"].replace(/^0+/, ''), "FG Number": obj["FGMATNR"].replace(/^0+/, ''), "FG Description": obj["FGMAKTX"].replace(',', ' '), "Material": "'" + obj["RMMATNR"].replace(/^0+/, ''), "Subcon Identifier": obj["SUBCON"], "Material Description": obj["RMMAKTX"].replace(',', ' '), "GrV": obj["J_3ASIZE"], "Purchase Group": obj["EKGRP"], "Purchase Group Desc": obj["EKNAM"].replace(',', ' '), "Material Type": obj["MTART"], "Storage Location": obj["LGORT"], "Customer Name": obj["EWBEZ"], "Customer": obj["EXTWG"], "Material Group": obj["MATKL"], "Factory": obj["NAME1"], "Production Start Date": obj["START_DATE"], "PCD": obj["CUT_DATE"], "RqDlv.date": obj["J_3ARQDA"], "Total Requirement": obj["REQ_QTY"], "Total Assigned Stock": obj["ASSIGNED_QTY"], "Missing Qty": obj["MISSING_QTY"], "UR Stock": obj["UR_STOCK"], "QI Stock": obj["QI_STOCK"], "Fixed UR Stock": obj["FIXED_UR_STOCK"], "Fixed QI Stock": obj["FIXED_QI_STOCK"], "Blocked Stock": obj["BLOCKED_STOCK"], "PickList Qty": obj["PICKLIST_QTY"], "Excludes": obj["EXCLUDED"] };
              this.summaryReport.push(this.downloadDataSum);
            }

            this.ExportToExcel(this.summaryReport, 'SummaryReport.csv');
          }
          else {
            for (var obj of data) {
              this.downloadDataSum = { "Plant": obj["WERKS"], "Sales Order": obj["VBELN"], "Line Item": obj["POSNR"], "Production Order": obj["AUFNR"].replace(/^0+/, ''), "FG Number": obj["FGMATNR"].replace(/^0+/, ''), "FG Description": obj["FGMAKTX"].replace(',', ' '), "Material": "'" + obj["RMMATNR"].replace(/^0+/, ''), "Subcon Identifier": obj["SUBCON"], "Material Description": obj["RMMAKTX"].replace(',', ' '), "Production Order Status": obj["PRD_STATUS"], "GrV": obj["J_3ASIZE"], "Purchase Group": obj["EKGRP"], "Purchase Group Desc": obj["EKNAM"].replace(',', ' '), "Material Type": obj["MTART"], "Storage Location": obj["LGORT"], "Customer Name": obj["EWBEZ"], "Customer": obj["EXTWG"], "Material Group": obj["MATKL"], "Work Center": obj["ARBPL"], "Factory": obj["NAME1"], "Value Stream": obj["VALUEST"], "Production Start Date": obj["START_DATE"], "PCD": obj["CUT_DATE"], "RqDlv.date": obj["J_3ARQDA"], "Total Requirement": obj["REQ_QTY"], "Total Assigned Stock": obj["ASSIGNED_QTY"], "Missing Qty": obj["MISSING_QTY"], "UR Stock": obj["UR_STOCK"], "QI Stock": obj["QI_STOCK"], "Fixed UR Stock": obj["FIXED_UR_STOCK"], "Fixed QI Stock": obj["FIXED_QI_STOCK"], "Blocked Stock": obj["BLOCKED_STOCK"], "PickList Qty": obj["PICKLIST_QTY"], "Excludes": obj["EXCLUDED"] };
              this.summaryReport.push(this.downloadDataSum);
            }

            this.ExportToExcel(this.summaryReport, 'SummaryReport.csv');
          }

        }

      }, error => {
        console.log("Error", error);
      });
  }

  clickBox(item: any) {
    if (item["BOX_COLOR"] == "RG" || item["BOX_COLOR"] == "RB" || item["BOX_COLOR"] == "R" || item["BOX_COLOR"] == "G") {
      this.clickModalRed = true;
      this.showLoadMsg_1 = true;
      this.summaryReport = [];
      this.DetailReport = [];

      this.txtBoxDate = item["BOX_DATE"];
      this.txtfactoryLine = item["FACTORY_LINE"];
      let re = /\//gi;

      this.selectedFactory = "Selected Factory : " + item["FACTORY_LINE"];
      this.selectedDate = "Date : " + item["BOX_DATE"];
      // this.dataservice.GetRedButtonSummaryDetailReport(this.tokenID,item["BOX_DATE"],item["FACTORY_LINE"])

      this.dataservice.GetRedButtonSummaryDetailReport(this.tokenID, item["BOX_DATE"], item["FACTORY_LINE"], this.opt)
        .subscribe(data => {
          console.log("GET is successful ", data);

          if (data["m_Item2"].length == 0 || data["m_Item1"].length == 0) {

            this.showLoadMsg_1 = false;
          }
          else {
            this.summaryReport = data["m_Item2"];
            // if (this.opt == "S") {
            //   for (var obj of data["m_Item2"]) {
            //     this.modalViewSummary = { "WERKS": obj["WERKS"], "VBELN": obj["VBELN"], "POSNR": obj["POSNR"], "AUFNR": obj["AUFNR"].replace(/^0+/, ''), "FGMATNR": obj["FGMATNR"].replace(/^0+/, ''), "FGMAKTX": obj["FGMAKTX"], "RMMATNR": obj["RMMATNR"].replace(/^0+/, ''), "RMMAKTX": obj["RMMAKTX"], "PRD_STATUS": obj["PRD_STATUS"], "J_3ASIZE": obj["J_3ASIZE"], "EKGRP": obj["EKGRP"], "MTART": obj["MTART"], "LGORT": obj["LGORT"], "EWBEZ": obj["EWBEZ"], "EXTWG": obj["EXTWG"], "MATKL": obj["MATKL"],"ARBPL": obj["ARBPL"], "NAME1": obj["NAME1"], "VALUEST": obj["VALUEST"], "START_DATE": obj["START_DATE"], "CUT_DATE": obj["CUT_DATE"], "J_3ARQDA": obj["J_3ARQDA"], "REQ_QTY": obj["REQ_QTY"], "ASSIGNED_QTY": obj["ASSIGNED_QTY"], "MISSING_QTY": obj["MISSING_QTY"], "UR_STOCK": obj["UR_STOCK"], "QI_STOCK": obj["QI_STOCK"], "FIXED_UR_STOCK": obj["FIXED_UR_STOCK"], "FIXED_QI_STOCK": obj["FIXED_QI_STOCK"], "BLOCKED_STOCK": obj["BLOCKED_STOCK"], "EXCLUDED": obj["EXCLUDED"], "MVD_COMMENT": obj["MVD_COMMENT"],"MANDT":obj["MANDT"], "CHARG": obj["CHARG"],"RMMATNR1": obj["RMMATNR"]};
            //     this.summaryReport.push(this.modalViewSummary);
            //   }
            // }
            // else {
            //   for (var obj of data["m_Item2"]) {
            //     this.modalViewSummary = { "WERKS": obj["WERKS"], "VBELN": obj["VBELN"], "POSNR": obj["POSNR"], "AUFNR": obj["AUFNR"].replace(/^0+/, ''), "FGMATNR": obj["FGMATNR"].replace(/^0+/, ''), "FGMAKTX": obj["FGMAKTX"], "RMMATNR": obj["RMMATNR"].replace(/^0+/, ''), "RMMAKTX": obj["RMMAKTX"], "PRD_STATUS": obj["PRD_STATUS"], "J_3ASIZE": obj["J_3ASIZE"], "EKGRP": obj["EKGRP"], "MTART": obj["MTART"], "LGORT": obj["LGORT"], "EWBEZ": obj["EWBEZ"], "EXTWG": obj["EXTWG"], "MATKL": obj["MATKL"], "ARBPL": obj["ARBPL"], "NAME1": obj["NAME1"], "VALUEST": obj["VALUEST"], "START_DATE": obj["START_DATE"], "CUT_DATE": obj["CUT_DATE"], "J_3ARQDA": obj["J_3ARQDA"], "REQ_QTY": obj["REQ_QTY"], "ASSIGNED_QTY": obj["ASSIGNED_QTY"], "MISSING_QTY": obj["MISSING_QTY"], "UR_STOCK": obj["UR_STOCK"], "QI_STOCK": obj["QI_STOCK"], "FIXED_UR_STOCK": obj["FIXED_UR_STOCK"], "FIXED_QI_STOCK": obj["FIXED_QI_STOCK"], "BLOCKED_STOCK": obj["BLOCKED_STOCK"], "EXCLUDED": obj["EXCLUDED"], "MVD_COMMENT": obj["MVD_COMMENT"],"MANDT":obj["MANDT"], "CHARG": obj["CHARG"],"RMMATNR1": obj["RMMATNR"] };
            //     this.summaryReport.push(this.modalViewSummary);
            //   }
            // }
            this.DetailReport = data["m_Item1"];
            // if (this.opt == "S") {
            //   for (var obj of data["m_Item1"]) {
            //     this.modalViewDetail = { "WERKS": obj["WERKS"], "VBELN": obj["VBELN"], "POSNR": obj["POSNR"], "AUFNR": obj["AUFNR"].replace(/^0+/, ''), "FGMATNR": obj["FGMATNR"].replace(/^0+/, ''), "FGMAKTX": obj["FGMAKTX"], "RMMATNR": obj["RMMATNR"].replace(/^0+/, ''), "RMMAKTX": obj["RMMAKTX"], "J_3ASIZE": obj["J_3ASIZE"], "EKGRP": obj["EKGRP"], "MTART": obj["MTART"], "LGORT": obj["LGORT"], "EWBEZ": obj["EWBEZ"], "EXTWG": obj["EXTWG"], "MATKL": obj["MATKL"], "NAME1": obj["NAME1"], "START_DATE": obj["START_DATE"],"ARBPL": obj["ARBPL"], "CUT_DATE": obj["CUT_DATE"], "J_3ARQDA": obj["J_3ARQDA"], "CHARG": obj["CHARG"], "REQ_QTY": obj["REQ_QTY"], "ASSIGNED_QTY": obj["ASSIGNED_QTY"], "MISSING_QTY": obj["MISSING_QTY"], "UR_STOCK": obj["UR_STOCK"], "QI_STOCK": obj["QI_STOCK"], "FIXED_UR_STOCK": obj["FIXED_UR_STOCK"], "FIXED_QI_STOCK": obj["FIXED_QI_STOCK"], "BLOCKED_STOCK": obj["BLOCKED_STOCK"], "EXCLUDED": obj["EXCLUDED"], "MVD_COMMENT": obj["MVD_COMMENT"],"MANDT":obj["MANDT"],"RMMATNR1": obj["RMMATNR"] };
            //     this.DetailReport.push(this.modalViewDetail);
            //   }
            // }
            // else {
            //   for (var obj of data["m_Item1"]) {
            //     this.modalViewDetail = { "WERKS": obj["WERKS"], "VBELN": obj["VBELN"], "POSNR": obj["POSNR"], "AUFNR": obj["AUFNR"].replace(/^0+/, ''), "FGMATNR": obj["FGMATNR"].replace(/^0+/, ''), "FGMAKTX": obj["FGMAKTX"], "RMMATNR": obj["RMMATNR"].replace(/^0+/, ''), "RMMAKTX": obj["RMMAKTX"], "PRD_STATUS": obj["PRD_STATUS"], "J_3ASIZE": obj["J_3ASIZE"], "EKGRP": obj["EKGRP"], "MTART": obj["MTART"], "LGORT": obj["LGORT"], "EWBEZ": obj["EWBEZ"], "EXTWG": obj["EXTWG"], "MATKL": obj["MATKL"], "ARBPL": obj["ARBPL"], "NAME1": obj["NAME1"], "VALUEST": obj["VALUEST"], "START_DATE": obj["START_DATE"], "CUT_DATE": obj["CUT_DATE"], "J_3ARQDA": obj["J_3ARQDA"], "CHARG": obj["CHARG"], "REQ_QTY": obj["REQ_QTY"], "ASSIGNED_QTY": obj["ASSIGNED_QTY"], "MISSING_QTY": obj["MISSING_QTY"], "UR_STOCK": obj["UR_STOCK"], "QI_STOCK": obj["QI_STOCK"], "FIXED_UR_STOCK": obj["FIXED_UR_STOCK"], "FIXED_QI_STOCK": obj["FIXED_QI_STOCK"], "BLOCKED_STOCK": obj["BLOCKED_STOCK"], "EXCLUDED": obj["EXCLUDED"], "MVD_COMMENT": obj["MVD_COMMENT"],"MANDT":obj["MANDT"],"RMMATNR1": obj["RMMATNR"] };
            //     this.DetailReport.push(this.modalViewDetail);
            //   }
            // }
            this.showLoadMsg_1 = false;
          }
        }, error => {
          console.log("Error", error);
        });
    }
    else {
      this.clickModalRed = false;
    }

  }

  ExportToExcel(downloadArray: any[], fileName: string) {
    var csvData = this.ConvertToCSV(downloadArray);
    var a = document.createElement("a");
    //a.style.backgroundColor="Blue"
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;//'download.csv';/* your file name*/
    a.click();
    return 'success';


  }

  ConvertToCSV(objArray: any) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line != '') line += ','

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }

  Clear() {
    this.opt = "";
    this.txtPlant = "";
    this.txtFactory = "";
    this.txtValueStream = "";
    this.txtstartDate = null;
    this.txtendDate = null;
    this.txtCustomer = "";
    this.txtStyle = "";
    this.txtFGNum = "";
    this.txtMatType = "";
    this.txtrawMatCode = "";
    this.txtMatGrp = "";
    this.txtpuchGrp = "";
    this.txtPO = "";
    this.txtSO = "";
    this.txtLineItem = "";
    this.showoutput = false;
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.selectedPlants = [];
    this.selectedStoLocation = null;
    this.selectedColours = [];
    this.txtMulFactory = "";
    this.txtMulValueStream = "";
    this.txtMulCustomer = "";
    this.txtMulStyle = "";
    this.txtMulFGNum = "";
    this.txtMulMatType = "";
    this.txtMulMatCode = "";
    this.txtMulMatGrp = "";
    this.txtMulpuchGrp = "";
    this.txtMulPO = "";
    this.txtMulSO = "";
    this.txtMulLineItem = "";
    this.showLoadMsg = false;
    this.req = false;
    this.hidePO = false;
    this.hideSO = false;
    this.mngErrors = false;
  }



  CommentEdit(item: any) {
    this.CommentMessage = "";
    this.commentMsgShow = false;
    var comment = prompt("Comment", "comment");
    if (comment != null) {
      this.dataservice.SaveDetails(item["MANDT"], item["WERKS"], item["START_DATE"], item["ARBPL"], item["RMMATNR"], item["J_3ASIZE"], item["VBELN"], item["POSNR"], item["AUFNR"], item["LGORT"], item["CHARG"], comment, this.username)
        .subscribe(response => {
          if (response.toString() == null || response.toString() == "") {
            item["MVD_COMMENT"] = comment;
            item["MVD_COMMENT_USER"] = this.username;
            console.log("POST is successful ", response);
          }
          else {
            this.CommentMessage = response.toString();
            this.commentMsgShow = true;
            // var errorMsg = prompt(this.CommentMessage);

            this.confirmationService.confirm({
              message: this.CommentMessage,
              header: 'Error',
              icon: 'pi pi-exclamation-triangle',
              // accept: () => {
              //     this.msgs = [{severity:'info', summary:'Confirmed', detail:'You have accepted'}];
              // },
              // reject: () => {
              //     this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
              // }
            });

          }


        }, error => {
          console.log("Error", error);
        });
      // alert("save - " + comment + " - " + item);
      this.index = this.index + 1;
    }
  }

  CommentEditAll(item: any) {
    debugger;
    this.CommentMessage = "";
    this.commentMsgShow = false;
    var comment = prompt("Supply Chain User Comment", "comment");

    if (!this.selectedLineItems.includes(item)) {
      this.selectedLineItems.push(item);
    }
    if (comment != null) {
      this.selectedLineItems.forEach(element => {
        element.MVD_COMMENT = comment;
        element.MVD_COMMENT_USER = this.username;
      });

      this.dataservice.SaveAllDetails(this.selectedLineItems)
        .subscribe(response => {
          if (response.toString() == null || response.toString() == "") {
            this.selectedLineItems.forEach(element => {
              element["MVD_COMMENT"] = comment;
              element["MVD_COMMENT_USER"] = this.username;
            });
            console.log("POST is successful ", response);
          }
          else {
            this.CommentMessage = response.toString();
            this.commentMsgShow = true;
            // var errorMsg = prompt(this.CommentMessage);

            this.confirmationService.confirm({
              message: this.CommentMessage,
              header: 'Error',
              icon: 'pi pi-exclamation-triangle',
              // accept: () => {
              //     this.msgs = [{severity:'info', summary:'Confirmed', detail:'You have accepted'}];
              // },
              // reject: () => {
              //     this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
              // }
            });

          }
        }, error => {
          console.log("Error", error);
        });
      // alert("save - " + comment + " - " + item);
      this.index = this.index + 1;

    }

    this.selectedLineItems = [];

    for (var i = 0; i < this.DetailReport.length; i++) {
      let test = document.getElementById("test_" + i) as HTMLInputElement;
      test.checked = false;
    }

    let all = document.getElementById("all") as HTMLInputElement;
    all.checked = false;

  }

  CommentEditAll_RMW(item: any) {
    debugger;
    this.CommentMessage = "";
    this.commentMsgShow = false;
    var comment = prompt("RMW User Comment", "comment");

    if (!this.selectedLineItems.includes(item)) {
      this.selectedLineItems.push(item);
    }

    if (comment != null) {
      this.selectedLineItems.forEach(element => {
        element.RMW_COMMENT = comment;
        element.RMW_COMMENT_USER = this.username;
      });

      this.dataservice.SaveAllDetails(this.selectedLineItems)
        .subscribe(response => {
          if (response.toString() == null || response.toString() == "") {
            this.selectedLineItems.forEach(element => {
              element["RMW_COMMENT"] = comment;
              element["RMW_COMMENT_USER"] = this.username;
            });
            console.log("POST is successful ", response);
          }
          else {
            this.CommentMessage = response.toString();
            this.commentMsgShow = true;
            // var errorMsg = prompt(this.CommentMessage);

            this.confirmationService.confirm({
              message: this.CommentMessage,
              header: 'Error',
              icon: 'pi pi-exclamation-triangle',
              // accept: () => {
              //     this.msgs = [{severity:'info', summary:'Confirmed', detail:'You have accepted'}];
              // },
              // reject: () => {
              //     this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
              // }
            });

          }
        }, error => {
          console.log("Error", error);
        });
      // alert("save - " + comment + " - " + item);
      this.index = this.index + 1;

    }

    this.selectedLineItems = [];

    for (var i = 0; i < this.DetailReport.length; i++) {
      let test = document.getElementById("test_" + i) as HTMLInputElement;
      test.checked = false;
    }

    let all = document.getElementById("all") as HTMLInputElement;
    all.checked = false;

  }

  CommentEditAll_MQA(item: any) {
    debugger;
    this.CommentMessage = "";
    this.commentMsgShow = false;
    var comment = prompt("MQA User Comment", "comment");

    if (!this.selectedLineItems.includes(item)) {
      this.selectedLineItems.push(item);
    }

    if (comment != null) {
      this.selectedLineItems.forEach(element => {
        element.MQA_COMMENT = comment;
        element.MQA_COMMENT_USER = this.username;
      });

      this.dataservice.SaveAllDetails(this.selectedLineItems)
        .subscribe(response => {
          if (response.toString() == null || response.toString() == "") {
            this.selectedLineItems.forEach(element => {
              element["MQA_COMMENT"] = comment;
              element["MQA_COMMENT_USER"] = this.username;
            });
            console.log("POST is successful ", response);
          }
          else {
            this.CommentMessage = response.toString();
            this.commentMsgShow = true;
            // var errorMsg = prompt(this.CommentMessage);

            this.confirmationService.confirm({
              message: this.CommentMessage,
              header: 'Error',
              icon: 'pi pi-exclamation-triangle',
              // accept: () => {
              //     this.msgs = [{severity:'info', summary:'Confirmed', detail:'You have accepted'}];
              // },
              // reject: () => {
              //     this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
              // }
            });

          }
        }, error => {
          console.log("Error", error);
        });
      // alert("save - " + comment + " - " + item);
      this.index = this.index + 1;

    }

    this.selectedLineItems = [];

    for (var i = 0; i < this.DetailReport.length; i++) {
      let test = document.getElementById("test_" + i) as HTMLInputElement;
      test.checked = false;
    }

    let all = document.getElementById("all") as HTMLInputElement;
    all.checked = false;

  }

  CommentEditAll_MCU(item: any) {
    debugger;
    this.CommentMessage = "";
    this.commentMsgShow = false;
    var comment = prompt("MCU User Comment", "comment");

    debugger;
    if (!this.selectedLineItems.includes(item)) {
      this.selectedLineItems.push(item);
    }

    if (comment != null) {
      this.selectedLineItems.forEach(element => {
        element.MCU_COMMENT = comment;
        element.MCU_COMMENT_USER = this.username;
      });

      this.dataservice.SaveAllDetails(this.selectedLineItems)
        .subscribe(response => {
          if (response.toString() == null || response.toString() == "") {
            this.selectedLineItems.forEach(element => {
              element["MCU_COMMENT"] = comment;
              element["MCU_COMMENT_USER"] = this.username;
            });
            console.log("POST is successful ", response);
          }
          else {
            this.CommentMessage = response.toString();
            this.commentMsgShow = true;
            // var errorMsg = prompt(this.CommentMessage);

            this.confirmationService.confirm({
              message: this.CommentMessage,
              header: 'Error',
              icon: 'pi pi-exclamation-triangle',
              // accept: () => {
              //     this.msgs = [{severity:'info', summary:'Confirmed', detail:'You have accepted'}];
              // },
              // reject: () => {
              //     this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
              // }
            });

          }
        }, error => {
          console.log("Error", error);
        });
      // alert("save - " + comment + " - " + item);
      this.index = this.index + 1;

    }

    this.selectedLineItems = [];

    for (var i = 0; i < this.DetailReport.length; i++) {
      let test = document.getElementById("test_" + i) as HTMLInputElement;
      test.checked = false;
    }

    let all = document.getElementById("all") as HTMLInputElement;
    all.checked = false;
  }

  formatNullDates(date: string) {
    if (date.includes("0000-00-00")) {
      return "";
    }
    else {
      return date;
    }
  }

  //select a line item when check box is selected
  SelectLineItem(item: any, event: any) {
    if (event.target.checked) {
      this.selectedLineItems.push(item);
    }
    else {
      var index = this.selectedLineItems.indexOf(item);
      this.selectedLineItems.splice(index, 1);
    }
  }

  SelectAllLineItem(event: any) {
    debugger;
    if (event.target.checked) {
      // if (this.selectedLineItems.length > 0) {
      for (var i = 0; i < this.DetailReport.length; i++) {
        let test = document.getElementById("test_" + i) as HTMLInputElement;
        test.checked = true;
      }
      this.DetailReport.forEach(element => {
        this.selectedLineItems.push(element);
      });      // }      
    }
    else {
      for (var i = 0; i < this.DetailReport.length; i++) {
        let test = document.getElementById("test_" + i) as HTMLInputElement;
        test.checked = false;
      }
      this.selectedLineItems = [];
    }
  }

  //Factory
  showDialog() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.display = true;

  }
  clickYes() {
    this.txtFactory = this.txtMulFactory.replace(/\n/g, ",");
    this.display = false;
  }

  clearFactory() {
    this.txtMulFactory = "";
  }
  //value stresm
  showDialogValueStream() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayValStre = true;
  }
  saveValueStream() {
    this.txtValueStream = this.txtMulValueStream.replace(/\n/g, ",");
    this.displayValStre = false;
  }

  clearValStream() {
    this.txtMulValueStream = "";
  }

  //SO
  showDialogSO() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displaytxtSO = true;
  }
  saveSO() {
    this.txtSO = this.txtMulSO.replace(/\n/g, ",");
    this.displaytxtSO = false;
  }

  clearSO() {
    this.txtMulSO = "";
  }

  //LineItem
  showDialogLineItem() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displaytxtLineItem = true;
  }
  saveLineItem() {
    this.txtSO = this.txtMulLineItem.replace(/\n/g, ",");
    this.displaytxtLineItem = false;
  }

  clearLineItem() {
    this.txtMulLineItem = "";
  }

  //PO
  showDialogPO() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displaytxtPO = true;
  }
  savePO() {
    this.txtPO = this.txtMulPO.replace(/\n/g, ",");
    this.displaytxtPO = false;
  }

  clearPO() {
    this.txtMulPO = "";
  }

  //Customer
  showDialogCustomer() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayCustomer = true;
  }
  saveCustomer() {
    this.txtCustomer = this.txtMulCustomer.replace(/\n/g, ",");
    this.displayCustomer = false;
  }

  clearCustomer() {
    this.txtMulCustomer = "";
  }

  //Style
  showDialogStyle() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayStyle = true;
  }
  saveStyle() {
    this.txtStyle = this.txtMulStyle.replace(/\n/g, ",");
    this.displayStyle = false;
  }

  clearStyle() {
    this.txtMulStyle = "";
  }
  //FGNum
  showDialogFGNum() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayFGNum = true;
  }
  saveFGNum() {
    this.txtFGNum = this.txtMulFGNum.replace(/\n/g, ",");
    this.displayFGNum = false;
  }

  clearFGNum() {
    this.txtMulSO = "";
  }

  //MatType
  showDialogMatType() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayMatType = true;
  }
  saveMatType() {
    this.txtMatType = this.txtMulMatType.replace(/\n/g, ",");
    this.displayMatType = false;
  }

  clearMatType() {
    this.txtMulMatType = "";
  }

  //MatCode
  showDialogMatCode() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayMatCode = true;
  }
  saveMatCode() {
    this.txtrawMatCode = this.txtMulMatCode.replace(/\n/g, ",");
    this.displayMatCode = false;
  }

  clearMatCode() {
    this.txtMulMatCode = "";
  }

  //MatGrp
  showDialogMatGrp() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displayMatGrp = true;
  }
  saveMatGrp() {
    this.txtMatGrp = this.txtMulMatGrp.replace(/\n/g, ",");
    this.displayMatGrp = false;
  }

  clearMatGrp() {
    this.txtMulMatGrp = "";
  }

  //puchGrp
  showDialogpuchGrp() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.displaypuchGrp = true;
  }
  savepuchGrp() {
    this.txtpuchGrp = this.txtMulpuchGrp.replace(/\n/g, ",");
    this.displaypuchGrp = false;
  }

  clearpuchGrp() {
    this.txtMulpuchGrp = "";
  }

  factoryChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }

  plantChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }

  valStreamChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  stoLocationChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  soChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  LIChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  POChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  custChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  styleChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  fgNumChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  matTypeChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  rawMatChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  matGrpChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  purchGrpChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }
  colIndiChange() {
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.rmPercentage = "";
  }

  SOLILabelClick() {
    this.opt = "S";
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.hidePO = true;
    this.hideSO = false;
    this.showSOSummaryDetail = true;
    this.showPOSummaryDetail = false;
    this.req = true;
  }

  POLabelClick() {
    this.opt = "P";
    this.displayBoxArr = [];
    this.lines = [];
    this.summaryReport = [];
    this.DetailReport = [];
    this.hidePO = false;
    this.hideSO = true;
    this.showSOSummaryDetail = false;
    this.showPOSummaryDetail = true;
    this.req = false;
  }

  LogOut() {
    this.adalSvc.logout(); //with single sign on
    //this.router.navigateByUrl('/login'); //without single sign on
  }
}
